import React from 'react';
import { motion } from 'framer-motion';
import { Eye, CheckSquare, Home, ArrowRight, ArrowDown } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-10 bg-white overflow-hidden" data-id="element-284">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-285">
        <div className="text-center mb-10" data-id="element-286">
          <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 mb-4" data-id="element-287">
            Imagina esto (de verdad)
          </h2>
          <p className="text-xl text-stone-600 max-w-2xl mx-auto" data-id="element-288">
            Tu hijo se levanta. En vez de que tú seas un altavoz... hay un
            tablero.
          </p>
        </div>

        {/* Steps Visualization */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-12 relative" data-id="element-289">
          {/* Step 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="w-full md:w-1/3 bg-amber-50 border-2 border-amber-200 rounded-2xl p-8 text-center relative z-10" data-id="element-290">
            <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4 text-amber-600" data-id="element-291">
              <Eye className="w-8 h-8" data-id="element-292" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-293">
              Ve el tablero
            </h3>
            <p className="text-stone-600" data-id="element-294">
              Sabe qué sigue sin que nadie le diga
            </p>
          </motion.div>

          {/* Arrow Desktop */}
          <div className="hidden md:block text-stone-300" data-id="element-295">
            <ArrowRight className="w-8 h-8" data-id="element-296" />
          </div>
          {/* Arrow Mobile */}
          <div className="md:hidden text-stone-300" data-id="element-297">
            <ArrowDown className="w-8 h-8" data-id="element-298" />
          </div>

          {/* Step 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="w-full md:w-1/3 bg-amber-50 border-2 border-amber-200 rounded-2xl p-8 text-center relative z-10" data-id="element-299">
            <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4 text-amber-600" data-id="element-300">
              <CheckSquare className="w-8 h-8" data-id="element-301" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-302">
              Marca lo que hizo
            </h3>
            <p className="text-stone-600" data-id="element-303">Siente logro y avanza solo</p>
          </motion.div>

          {/* Arrow Desktop */}
          <div className="hidden md:block text-stone-300" data-id="element-304">
            <ArrowRight className="w-8 h-8" data-id="element-305" />
          </div>
          {/* Arrow Mobile */}
          <div className="md:hidden text-stone-300" data-id="element-306">
            <ArrowDown className="w-8 h-8" data-id="element-307" />
          </div>

          {/* Step 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="w-full md:w-1/3 bg-amber-50 border-2 border-amber-200 rounded-2xl p-8 text-center relative z-10" data-id="element-308">
            <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4 text-amber-600" data-id="element-309">
              <Home className="w-8 h-8" data-id="element-310" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-311">
              Hay secuencia
            </h3>
            <p className="text-stone-600" data-id="element-312">
              Y cuando hay secuencia... hay calma
            </p>
          </motion.div>
        </div>

        {/* Product Reveal */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-amber-400 to-emerald-500 rounded-3xl p-8 md:p-16 text-center text-white shadow-2xl relative overflow-hidden" data-id="element-313">
          <div className="absolute top-0 left-0 w-full h-full bg-white/10 backdrop-blur-[2px] z-0" data-id="element-314"></div>
          <div className="relative z-10" data-id="element-315">
            <p className="text-lg md:text-xl font-medium mb-2 opacity-90" data-id="element-316">
              Por eso existe
            </p>
            <h2 className="text-4xl md:text-6xl font-black mb-6 tracking-tight drop-shadow-md" data-id="element-317">
              Rutinas Visuales sin Gritos
            </h2>
            <p className="text-xl md:text-2xl mb-10 max-w-3xl mx-auto font-medium leading-relaxed" data-id="element-318">
              El sistema visual paso a paso para reducir conflictos diarios y
              lograr cooperación real desde la primera semana.
            </p>

            <div className="max-w-xs mx-auto transform hover:scale-105 transition-transform duration-500" data-id="element-319">
              <img src="https://cdn.magicpatterns.com/uploads/hvXL76bFsKdc8oM4do4aCD/ChatGPT_Image_3_mar_2026,_10_55_20_p.m..png" alt="Sistema completo Rutinas Visuales sin Gritos" className="w-full h-auto rounded-xl shadow-2xl border-4 border-white/20" data-id="element-320" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}